import React from 'react'
import { string, bool, oneOf } from 'prop-types'
import StepIndicator from './StepIndicator'

function CustomSolutionCardStep({
  stepNumber,
  stepTitle,
  stepDescription,
  highlightStep = false,
  position = 'first',
}) {
  return (
    <div className="custom-solutions__step">
      <StepIndicator
        position={position}
        stepNumber={stepNumber}
        highlightStep={highlightStep}
      />

      <div className="custom-solutions__step-content">
        <h5 className="custom-solutions__step-title text-white font-weight-600">{stepTitle}</h5>
        <p className="text-light-grey cgt-legacy-text-default">{stepDescription}</p>
      </div>
    </div>
  )
}

CustomSolutionCardStep.propTypes = {
  stepNumber: string.isRequired,
  stepTitle: string.isRequired,
  stepDescription: string.isRequired,
  highlightStep: bool,
  position: oneOf(['first', 'middle', 'last']),
}

export default CustomSolutionCardStep
